module.exports = __webpack_public_path__ + "static/media/no-image.a4d1b5ae.png";